module.exports = __webpack_public_path__ + "img/grid-grey.99a0a9a0.svg";